import { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, Terminal } from "lucide-react";

function Block({ b }) {
  if (b.h) return <h2 className="font-heading font-bold text-white text-lg md:text-lg tracking-tight mt-10 mb-4">{b.h}</h2>;
  if (b.h3) return <h3 className="font-heading font-semibold text-slate-200 text-base tracking-tight mt-6 mb-2">{b.h3}</h3>;
  if (b.ul)
    return (
      <ul className="list-disc ps-6 mb-4 space-y-1.5">
        {b.ul.map((it, i) => (
          <li key={i} className="text-sm md:text-base text-slate-400 leading-relaxed">{it}</li>
        ))}
      </ul>
    );
  if (b.card)
    return (
      <div className="glass-card rounded-2xl p-6 md:p-8 my-4">
        <ul className="space-y-2 text-sm md:text-base text-slate-300">
          {b.card.map((row, i) => (
            <li key={i}>
              <span className="text-slate-500">{row.label}:</span>{" "}
              {row.href ? (
                <a href={row.href} target={row.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className="text-[#5B7FFF] hover:underline">
                  {row.value}
                </a>
              ) : (
                row.value
              )}
            </li>
          ))}
        </ul>
      </div>
    );
  return <p className="text-sm md:text-base text-slate-400 leading-relaxed mb-4">{b.p}</p>;
}

export default function LegalPage({ data, lang = "tr", backPath = "/", testId }) {
  useEffect(() => {
    document.title = `${data.title} | CDN Bilişim`;
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
    window.scrollTo(0, 0);
  }, [data, lang]);

  return (
    <div className="min-h-screen bg-[#15171C]" data-testid={testId}>
      <header className="sticky top-0 z-50 border-b border-white/10 backdrop-blur-xl bg-[#15171C]/80">
        <div className="mx-auto max-w-4xl px-6 h-16 flex items-center justify-between">
          <Link to={backPath} className="flex items-center gap-2" data-testid="legal-logo-link">
            <span className="w-8 h-8 rounded-md glow-badge flex items-center justify-center">
              <Terminal size={16} />
            </span>
            <span className="font-heading font-black text-xl tracking-tighter text-white">
              CDN BİLİŞİM<span className="text-[#5B7FFF]">.</span>
            </span>
          </Link>
          <Link
            to={backPath}
            className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-[#5B7FFF] transition-colors"
            data-testid="legal-back-link"
          >
            <ArrowLeft size={16} className="rtl:-scale-x-100" /> {data.back}
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-6 py-16">
        <h1 className="font-heading font-black tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl">
          {data.title}
        </h1>
        {data.subtitle && <p className="mt-4 text-sm md:text-base text-slate-400">{data.subtitle}</p>}
        <p className="mt-4 text-sm text-[#5B7FFF] font-medium">{data.updated}</p>

        <div className="mt-10">
          {data.blocks.map((b, i) => (
            <Block key={i} b={b} />
          ))}
        </div>

        <p className="mt-14 pt-8 border-t border-white/5 text-xs text-slate-500">
          © {new Date().getFullYear()} CDN Bilişim.
        </p>
      </main>
    </div>
  );
}
